import { RouteConfig } from 'vue-router'
import { requireAuth } from '../auth'
import { universityRoutes } from '../constants/agency/'
const University = () => 
  import(/* webpackChunkName: "university" */ '@/pmd/pages/agency/UniversityPage.vue')
  .then(m => m.default)
export const university: RouteConfig[] = [
  {
    path: '/university',
    name: universityRoutes.default,
    component: University,
    beforeEnter: requireAuth,
    children: []
  },
]